import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats = {}, className = "" }) => {
  // Mock stats if none provided
  const defaultStats = {
    totalSymptomLogs: 24,
    averageSeverity: 4.2,
    gamesPlayed: 18,
    averageGameScore: 87,
    streakDays: 7,
    lastLogDate: '2025-08-24'
  };

  const currentStats = { ...defaultStats, ...stats };

  const statCards = [
    {
      id: 'symptoms',
      title: 'Symptom Logs',
      value: currentStats?.totalSymptomLogs,
      subtitle: 'This month',
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'severity',
      title: 'Avg Severity',
      value: `${currentStats?.averageSeverity}/10`,
      subtitle: 'Last 30 days',
      icon: 'TrendingDown',
      color: currentStats?.averageSeverity <= 4 ? 'text-success' : currentStats?.averageSeverity <= 6 ? 'text-warning' : 'text-error',
      bgColor: currentStats?.averageSeverity <= 4 ? 'bg-success/10' : currentStats?.averageSeverity <= 6 ? 'bg-warning/10' : 'bg-error/10'
    },
    {
      id: 'games',
      title: 'Games Played',
      value: currentStats?.gamesPlayed,
      subtitle: 'This month',
      icon: 'Gamepad2',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'performance',
      title: 'Avg Score',
      value: `${currentStats?.averageGameScore}%`,
      subtitle: 'Game performance',
      icon: 'Target',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className={`${className}`}>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {statCards?.map((stat) => (
          <div key={stat?.id} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
                <Icon name={stat?.icon} size={18} className={stat?.color} />
              </div>
            </div>
            
            <div>
              <div className={`text-2xl font-bold ${stat?.color} mb-1`}>
                {stat?.value}
              </div>
              <div className="text-sm text-muted-foreground">{stat?.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{stat?.subtitle}</div>
            </div>
          </div>
        ))}
      </div>
      {/* Streak Card */}
      <div className="bg-gradient-to-r from-accent to-accent/80 text-accent-foreground rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-accent-foreground/20 rounded-lg flex items-center justify-center">
              <Icon name="Flame" size={24} color="currentColor" />
            </div>
            <div>
              <div className="text-2xl font-bold">{currentStats?.streakDays} Days</div>
              <div className="text-sm opacity-80">Logging Streak</div>
            </div>
          </div>
          <div className="text-right">
            <div className="text-sm opacity-80">Keep it up!</div>
            <div className="text-xs opacity-60">Last log: {currentStats?.lastLogDate}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;